import React from "react";
import PropTypes from "prop-types";
import styles from "./RadioGroupInput.module.scss";

const RadioGroupInput = ({
  label,
  name,
  options,
  required,
  indent,
  handleOptionChange,
  error,
  inlineRadio,
  value: rdoValue,
}) => {
  return (
    // error !== undefined is to check if an error prop was passed, which will be passed for WorkExperience radiogroup, but not for openForRelocation
    <div
      onChange={handleOptionChange}
      className={`${styles.radioGroup} ${
        error !== undefined ? "work-experience" : styles.columnRadioGroup
      } ${indent ? styles.indent : ""} ${
        inlineRadio ? styles.inlineRadio : ""
      }`}
    >
      <label
        className={`${error ? styles.danger : ""} ${
          required ? styles.required : ""
        } ${styles.label} `}
      >
        {label}
      </label>
      <div className={styles.radioLabelGroup}>
        {options.map(({ value, text }) => {
          return (
            <label key={value} className={styles.radioLabel}>
              <input
                type="radio"
                className={styles.radio}
                name={name}
                value={value.toString()}
                required={required}
                defaultChecked={rdoValue.toString() === value.toString()}
              />
              <span className={styles.spanItem}>{text}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

RadioGroupInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  indent: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]).isRequired,
    })
  ).isRequired,
  handleOptionChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

export { RadioGroupInput };
